module.exports = __webpack_public_path__ + "assets/img/bnr@2x.519c9b96.png";